import cn from 'classnames';

import { Icon } from '../Icon/Icon';

import styles from './EnterFullscreenButton.module.scss';

type EnterFullscreenButtonProps = {
  ariaLabel?: string;
  className?: string;
  iconSize?: number;
  testID?: string;
  onClick: () => void;
};

export const EnterFullscreenButton = (props: EnterFullscreenButtonProps) => {
  const { ariaLabel, className, iconSize = 38, testID, onClick } = props;

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      data-testid={testID}
      className={cn(styles.container, className)}
      onClick={onClick}
    >
      <Icon name="expand" size={iconSize} />
    </button>
  );
};
